/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptimizationResponse
 */
export interface OptimizationResponse {
    /**
     * 
     * @type {number}
     * @memberof OptimizationResponse
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof OptimizationResponse
     */
    startTime: string;
}

/**
 * Check if a given object implements the OptimizationResponse interface.
 */
export function instanceOfOptimizationResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "startTime" in value;

    return isInstance;
}

export function OptimizationResponseFromJSON(json: any): OptimizationResponse {
    return OptimizationResponseFromJSONTyped(json, false);
}

export function OptimizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optimizationId': json['optimization_id'],
        'startTime': json['start_time'],
    };
}

export function OptimizationResponseToJSON(value?: OptimizationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optimization_id': value.optimizationId,
        'start_time': value.startTime,
    };
}

